export default __webpack_public_path__ + "static/media/logo.3655ef3a.png";